import { Expose, Type } from 'class-transformer';
import { SopWithRelationshipResponseDto } from './sop-relationship.dto';

export class ComplaintsProcessConfigResponseDto {
    /**
     * Unique identifier for the complaints process configuration
     * @example '123e4567-e89b-12d3-a456-426614174000'
     */
    @Expose()
    id: string;

    /**
     * Reference to the client information record
     * @example '123e4567-e89b-12d3-a456-426614174001'
     */
    @Expose()
    clientInformationRecordId: string;

    /**
     * Intake Report Organization ID
     * @example '123e4567-e89b-12d3-a456-426614174002'
     */
    @Expose()
    intakeReportOrganizationId: string;

    /**
     * Email for intake report system
     * @example 'intake@example.com'
     */
    @Expose()
    intakeReportEmail: string;

    /**
     * Phone number for intake reports
     * @example '+1-800-555-0123'
     */
    @Expose()
    intakeReportPhone: string;

    /**
     * Email where intake is first sent
     * @example 'first@example.com'
     */
    @Expose()
    firstProvidedToEmail: string;

    /**
     * Email Q&C receives from
     * @example 'qnc.receives@example.com'
     */
    @Expose()
    qncReceivesFromEmail: string;

    /**
     * Email Q&C sends to
     * @example 'qnc.sends@example.com'
     */
    @Expose()
    qncSendsToEmail: string;

    /**
     * Whether reconciliation is required for complaints
     * @example true
     */
    @Expose()
    reconciliationRequired: boolean;

    /**
     * Reconciliation frequency
     * @example 'Weekly'
     */
    @Expose()
    reconciliationFrequency: string;

    /**
     * Source of investigation reports
     * @example 'Client QA Department'
     */
    @Expose()
    investigationReportFrom: string;
    @Expose()
    investigationReportDueDays?: number;
    @Expose()
    zenProjectDueDays?: number;

    /**
     * Additional notes about complaints process configuration
     * @example 'Follow SOP-COMP-001 for complaint handling'
     */
    @Expose()
    notes: string;

    /**
     * Timestamp when the record was created
     * @example '2024-01-15T10:30:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    createdAt: Date;

    /**
     * Timestamp when the record was last updated
     * @example '2024-01-15T15:45:00.000Z'
     */
    @Expose()
    @Type(() => Date)
    updatedAt: Date;

    /**
     * Associated SOPs for this complaints process configuration
     */
    @Expose()
    @Type(() => SopWithRelationshipResponseDto)
    sops?: SopWithRelationshipResponseDto[];
}
